export default __webpack_public_path__ + "static/media/thongBaoTamNgung.a5aa5bd4.jpg";